import { useEffect, useMemo, useState } from 'react';
import { useQueryState } from '@ui/src';
import { CofStatus, Company } from '../../../common/types';
import { overviewCompaniesSchema } from '../variables/overview-companies';
import formatCompaniesList from '../helpers/format-companies-list';
import { useAppSelector } from '../../../../../../../store/use-store';

const useOverviewCompanies = () => {
  const [selectedTab, setSelectedTab] = useState<'current' | 'removed'>(
    'current',
  );
  const [selectedCompanies, setSelectedCompanies] = useState<Company[]>([]);

  const { sort, onSortChange, onFilterChange, filters } = useQueryState(
    overviewCompaniesSchema,
  );

  const { baseUserInformation } = useAppSelector(
    (state) => state.individualCustomers.info.overview,
  );

  const formattedData = useMemo(() => {
    const data = formatCompaniesList(
      baseUserInformation?.representativeOfOrganizations as unknown as Company[],
    );

    return data;
  }, [baseUserInformation?.representativeOfOrganizations]);

  useEffect(() => {
    if (formattedData) {
      if (selectedTab === 'current') {
        setSelectedCompanies(
          formattedData.filter(
            (item) =>
              item.status === CofStatus.APPROVED ||
              item.status === CofStatus.PENDING_REVIEW,
          ),
        );
      } else {
        setSelectedCompanies(
          formattedData.filter(
            (item) =>
              item.status !== CofStatus.APPROVED &&
              item.status !== CofStatus.PENDING_REVIEW,
          ),
        );
      }
    }
  }, [formattedData, selectedTab]);

  return {
    sort,
    onSortChange,
    onFilterChange,
    filters,
    selectedTab,
    setSelectedTab,
    selectedCompanies,
  };
};

export default useOverviewCompanies;
